var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkDte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_349_1562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_349_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1816 25.0352H1.75586V0.849609C1.75586 0.380625 2.13648 0 2.60547 0H17.332C17.801 0 18.1816 0.380625 18.1816 0.849609V25.0352ZM24.6953 12.5742C22.6619 12.5742 21.0137 10.926 21.0137 8.89258V6.62695C21.0137 6.15797 21.3943 5.77734 21.8633 5.77734H27.5273C27.9963 5.77734 28.377 6.15797 28.377 6.62695V8.89258C28.377 10.926 26.7287 12.5742 24.6953 12.5742Z",
    fill: "url(#paint0_linear_349_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6816 24.5352H2.25586V0.849609C2.25586 0.656767 2.41263 0.5 2.60547 0.5H17.332C17.5249 0.5 17.6816 0.656767 17.6816 0.849609V24.5352ZM24.6953 12.0742C22.9381 12.0742 21.5137 10.6498 21.5137 8.89258V6.62695C21.5137 6.43411 21.6704 6.27734 21.8633 6.27734H27.5273C27.7202 6.27734 27.877 6.43411 27.877 6.62695V8.89258C27.877 10.6498 26.4526 12.0742 24.6953 12.0742Z",
    stroke: "url(#paint1_linear_349_1562)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_b_349_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9336 10.7617H6.00391C5.53492 10.7617 5.1543 10.3811 5.1543 9.91211V4.24805C5.1543 3.77906 5.53492 3.39844 6.00391 3.39844H13.9336C14.4026 3.39844 14.7832 3.77906 14.7832 4.24805V9.91211C14.7832 10.3811 14.4026 10.7617 13.9336 10.7617ZM10.1398 22.3413L12.4054 18.3765C12.7288 17.8101 12.3199 17.1055 11.668 17.1055H9.73369L11.2732 14.4116C11.506 14.0044 11.3644 13.485 10.9571 13.2522C10.5499 13.0194 10.0311 13.161 9.79826 13.5683L7.53264 17.5331C7.20922 18.0995 7.61816 18.8041 8.2701 18.8041H10.2044L8.66488 21.4979C8.43209 21.9052 8.57369 22.4246 8.98094 22.6574C9.38818 22.8902 9.90701 22.7486 10.1398 22.3413ZM28.1504 29H0.849609C0.380625 29 0 28.6194 0 28.1504V25.8848C0 25.4158 0.380625 25.0352 0.849609 25.0352H28.1504C28.6194 25.0352 29 25.4158 29 25.8848V28.1504C29 28.6194 28.6194 29 28.1504 29ZM27.5273 3.22852C27.5273 2.75953 27.1467 2.37891 26.6777 2.37891C26.2087 2.37891 25.8281 2.75953 25.8281 3.22852V5.77734H27.5273V3.22852ZM23.5625 3.22852C23.5625 2.75953 23.1819 2.37891 22.7129 2.37891C22.2439 2.37891 21.8633 2.75953 21.8633 3.22852V5.77734H23.5625V3.22852ZM24.6953 12.5742C24.4025 12.5742 24.1187 12.5391 23.8457 12.4745V18.5215C23.8457 19.3026 23.2108 19.9375 22.4297 19.9375H18.1816V21.6367H22.4297C24.1476 21.6367 25.5449 20.2394 25.5449 18.5215V12.4745C25.2719 12.5391 24.9881 12.5742 24.6953 12.5742Z",
    fill: "url(#paint2_linear_349_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87206 17.6055L9.29958 16.8574L10.8391 14.1636L10.8391 14.1635C10.9348 13.996 10.8765 13.7821 10.709 13.6863C10.5417 13.5906 10.3283 13.6487 10.2324 13.8163L8.87206 17.6055ZM8.87206 17.6055H9.73369H11.668C11.9358 17.6055 12.1044 17.8952 11.9712 18.1286L9.70572 22.0932C9.60987 22.2609 9.39641 22.319 9.22907 22.2233C9.06153 22.1275 9.00323 21.9136 9.09897 21.7461L9.09899 21.746L10.6385 19.0522L11.066 18.3041H10.2044H8.2701C8.00232 18.3041 7.83369 18.0145 7.96676 17.7812C7.96679 17.7811 7.96681 17.7811 7.96684 17.781L10.2323 13.8164L8.87206 17.6055ZM13.9336 10.2617H6.00391C5.81106 10.2617 5.6543 10.105 5.6543 9.91211V4.24805C5.6543 4.0552 5.81106 3.89844 6.00391 3.89844H13.9336C14.1264 3.89844 14.2832 4.0552 14.2832 4.24805V9.91211C14.2832 10.105 14.1264 10.2617 13.9336 10.2617ZM28.1504 28.5H0.849609C0.656767 28.5 0.5 28.3432 0.5 28.1504V25.8848C0.5 25.6919 0.656767 25.5352 0.849609 25.5352H28.1504C28.3432 25.5352 28.5 25.6919 28.5 25.8848V28.1504C28.5 28.3432 28.3432 28.5 28.1504 28.5ZM26.6777 2.87891C26.8706 2.87891 27.0273 3.03567 27.0273 3.22852V5.27734H26.3281V3.22852C26.3281 3.03567 26.4849 2.87891 26.6777 2.87891ZM22.7129 2.87891C22.9057 2.87891 23.0625 3.03567 23.0625 3.22852V5.27734H22.3633V3.22852C22.3633 3.03567 22.52 2.87891 22.7129 2.87891ZM25.0449 13.0595V18.5215C25.0449 19.9633 23.8715 21.1367 22.4297 21.1367H18.6816V20.4375H22.4297C23.4869 20.4375 24.3457 19.5787 24.3457 18.5215V13.0595C24.4608 13.0692 24.5774 13.0742 24.6953 13.0742C24.8132 13.0742 24.9298 13.0692 25.0449 13.0595Z",
    stroke: "url(#paint3_linear_349_1562)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_349_1562",
    x: -16.2441,
    y: -18,
    width: 62.6211,
    height: 61.0352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_349_1562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_349_1562",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_349_1562",
    x: -18,
    y: -15.6211,
    width: 65,
    height: 62.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_349_1562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_349_1562",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_1562",
    x1: 3.25877,
    y1: 23.6218,
    x2: 25.4253,
    y2: 0.0509894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_1562",
    x1: 3.63501,
    y1: 1.96897,
    x2: 24.4373,
    y2: 25.6205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_349_1562",
    x1: 1.63722,
    y1: 27.4971,
    x2: 25.1662,
    y2: 1.86547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_349_1562",
    x1: 2.04707,
    y1: 4.47261,
    x2: 24.0927,
    y2: 30.1509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDte);
export default __webpack_public_path__ + "static/media/dark_dte.e2052ebb13346c0f1e91585fdf0b8ccb.svg";
export { ForwardRef as ReactComponent };